import type { ClusterCapabilityId } from './availableServices.config.ts';
import { useAvailableServicesContext } from './AvailableServicesContext.ts';

type ClusterCapabilityState = {
  /**
   * The Services API reports this capability running on the selected site. Stays `false` while
   * the pod list is unknown, so GET hooks gated on it never call an API the site does not deploy.
   */
  isAvailable: boolean;
  /** The pod list has settled, so `isAvailable` is an answer rather than "not known yet". */
  isResolved: boolean;
};

/**
 * Services-API view of a single cluster capability, for callers that gate one service.
 * Consumers needing several capabilities should read `clusterAvailableServiceSet` directly.
 */
export const useClusterCapability = (capabilityId: ClusterCapabilityId): ClusterCapabilityState => {
  const { clusterAvailableServiceSet } = useAvailableServicesContext();

  return {
    isAvailable: Boolean(clusterAvailableServiceSet?.has(capabilityId)),
    isResolved: clusterAvailableServiceSet !== null,
  };
};
